import React, { useEffect, useRef, useState } from 'react';
import { isEmpty } from 'lodash';
import { Icons, Box, Card, List, ListItem, ListItemIcon, ListItemText, Tab, Tabs, Typography } from "@curves/ui-base";
import { ReportTableHeader, SearchBar, TableLabel } from '@icoach/dataAnalysis/components/';
import { GuestProductionDailyTable, GuestProductionMonthlyTable } from '@icoach/dataAnalysis/tables/';
import useReportApi from '@apis/useReportApi';
import { tableTargetMap, guestProductionTabsItemType } from './staticData';
import { DataAnalysisProvider, useDataAnalysisContext } from '@icoach/dataAnalysis/components/DataAnalysisContext';

const taskMatterData = [
    {
        text: 'Staff電話話術教育訓練',
        isStar: false,
    },
    {
        text: '使用會員手冊及禮物以索取3個人名',
        isStar: false,
    },
    {
        text: '練習發招待卡以及追蹤發卡後續',
        isStar: false,
    },
];

const GuestProductionRemindersContent = () => {
    return (
        <Box className={'bg-light px-4 pt-2 pb-3'}>
            <Typography className={'font-weight-bold'} variant={'h5'}>
                Reminders
            </Typography>
            <Typography className={'font-color-3 mb-0'}>請確認下列項目是否有執行</Typography>
            <List className={'reminders-list'}>
                {!isEmpty(taskMatterData) &&
                    taskMatterData.map(({ text, isStar }) => (
                        <ListItem key={text}>
                            <ListItemIcon>
                                <Icons.NavigateNext />
                            </ListItemIcon>
                            <ListItemText primary={<TableLabel title={text} isStar={isStar} />} />
                        </ListItem>
                    ))}
            </List>
        </Box>
    );
};

const GuestProductionDailyContent = () => {
    const { data } = useDataAnalysisContext();
    const [tabsIndex, setTabsIndex] = useState(guestProductionTabsItemType.apo);

    const handleTabChange = (_, value) => {
        setTabsIndex(value);
    };

    return (
        <React.Fragment>
            <Box className="page-tabs tabs-bottom-line mb-4">
                <Tabs value={tabsIndex} variant="scrollable" scrollButtons="auto" onChange={handleTabChange}>
                    <Tab className={'py-3'} label={'APO'} value={guestProductionTabsItemType.apo} />
                    <Tab className={'py-3'} label={'名單數'} value={guestProductionTabsItemType.list} />
                    <Tab className={'py-3'} label={'詢問數'} value={guestProductionTabsItemType.ask} />
                    <Tab className={'py-3'} label={'FA數'} value={guestProductionTabsItemType.fa} />
                    <Tab className={'py-3'} label={'入會'} value={guestProductionTabsItemType.totalSales} />
                </Tabs>
            </Box>
            {!isEmpty(data) && <GuestProductionDailyTable tabsIndex={tabsIndex} rowsData={data[`${tabsIndex}Daily`]} />}
        </React.Fragment>
    );
};

const GuestProductionMonthlyContent = (props) => {
    const { defaultDate, data, dialogRef } = useDataAnalysisContext();
    const [tabsIndex, setTabsIndex] = useState(guestProductionTabsItemType.agp);

    const handleTabChange = (_, value) => {
        setTabsIndex(value);
    };

    return (
        <React.Fragment>
            <Box className="page-tabs tabs-bottom-line mb-4">
                <Tabs value={tabsIndex} variant="scrollable" scrollButtons="auto" onChange={handleTabChange}>
                    <Tab className={'py-3'} label={'AGP'} value={guestProductionTabsItemType.agp} />
                    <Tab className={'py-3'} label={'Calls'} value={guestProductionTabsItemType.calls} />
                    <Tab className={'py-3'} label={'APO'} value={guestProductionTabsItemType.apo} />
                    <Tab className={'py-3'} label={'入會'} value={guestProductionTabsItemType.totalSales} />
                </Tabs>
            </Box>
            {!isEmpty(data) && (
                <React.Fragment>
                    <GuestProductionMonthlyTable
                        className={'mb-4'}
                        defaultDate={defaultDate}
                        tabsIndex={tabsIndex}
                        rowsData={data[`${tabsIndex}Weekly`]}
                        cumulative={data[`${tabsIndex}Cumulative`]}
                        dialogRef={dialogRef}
                    />
                    <GuestProductionRemindersContent />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

const GuestProductionReportTableContent = () => {
    const [tableTarget, setTable] = useState(tableTargetMap.monthly);
    const handleToggleTable = (target) => {
        setTable(target);
    };

    return (
        <Card className={'mb-4'}>
            <Card.CardContent className={'px-4 pt-3 pb-4'}>
                <ReportTableHeader tableTarget={tableTarget} onToggleTable={handleToggleTable} />
                {tableTarget === tableTargetMap.daily && <GuestProductionDailyContent />}
                {tableTarget === tableTargetMap.monthly && <GuestProductionMonthlyContent />}
            </Card.CardContent>
        </Card>
    );
};

const DataAnalysisContentGuestProduction = (props) => {
    const { dialogRef, defaultDate } = props;
    const { getReportGuestProductionApi } = useReportApi();
    const [data, setData] = useState({});
    const searchRef = useRef(null);

    const doReportGuestProductionApi = async (params) => {
        let resp = await getReportGuestProductionApi(params);
        if (resp) {
            setData(resp);
        }
    };

    const getParams = () => {
        let result = {};
        if (searchRef.current && searchRef.current.getResult) {
            result = Object.assign(result, searchRef.current.getResult());
        }

        return result;
    };

    const handleSubmit = () => {
        let isError = searchRef.current && searchRef.current.isError();
        if (!isError) {
            let params = getParams();
            doReportGuestProductionApi(params);
        }
    };

    const childContext = {
        data,
        defaultDate,
        dialogRef,
    };

    useEffect(() => {
        handleSubmit();
        // eslint-disable-next-line
    }, []);

    return (
        <DataAnalysisProvider value={childContext}>
            <SearchBar ref={searchRef} className={'mb-4'} onSubmit={handleSubmit} />
            <GuestProductionReportTableContent />
        </DataAnalysisProvider>
    );
};

export default DataAnalysisContentGuestProduction;
